import { DatesHelpers } from "@core/helpers";

export const IBillingAriaFilters = Object.freeze({
  minDate: "dateMin",
  maxDate: "dateMax",
  dates: "dates",
  billingSessionStatus: "billing-session-status",
  creditLimitStatus: "credit-limit-status",
  loanStatus: "loan-status",
  stripeStatus: "stripe-status",
  invoiceStatus: "invoice-status",
  paymentMean: "payment-types",
  search: "search",
  searchType: "search-type",
  page: "page",
  take: "nb",
  sort: "sort",
});

export class BillingAriaFiltersModel {
  constructor(data = {}) {
    this[IBillingAriaFilters.dates] = data[IBillingAriaFilters.dates];
    this[IBillingAriaFilters.minDate] = data[IBillingAriaFilters.minDate];
    this[IBillingAriaFilters.maxDate] = data[IBillingAriaFilters.maxDate];
    this[IBillingAriaFilters.billingSessionStatus] = data[IBillingAriaFilters.billingSessionStatus] || [];
    this[IBillingAriaFilters.creditLimitStatus] = data[IBillingAriaFilters.creditLimitStatus] || [];
    this[IBillingAriaFilters.loanStatus] = data[IBillingAriaFilters.loanStatus] || [];
    this[IBillingAriaFilters.stripeStatus] = data[IBillingAriaFilters.stripeStatus] || [];
    this[IBillingAriaFilters.invoiceStatus] = data[IBillingAriaFilters.invoiceStatus] || [];
    this[IBillingAriaFilters.paymentMean] = data[IBillingAriaFilters.paymentMean] || [];
    this[IBillingAriaFilters.search] = data[IBillingAriaFilters.search];
    this[IBillingAriaFilters.searchType] = data[IBillingAriaFilters.searchType];
    this[IBillingAriaFilters.sort] = data[IBillingAriaFilters.sort];
    this[IBillingAriaFilters.page] = data[IBillingAriaFilters.page];
    this[IBillingAriaFilters.take] = data[IBillingAriaFilters.take];
  }

  hasDates() {
    return this[IBillingAriaFilters.dates]?.start && this[IBillingAriaFilters.dates]?.end;
  }

  getFormattedDates(format = "L") {
    const { start, end } = this[IBillingAriaFilters.dates];
    return {
      min: DatesHelpers.getDayjs(start).format(format),
      max: DatesHelpers.getDayjs(end).format(format),
    };
  }
}
